import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { LTime } from '@app/components/date/LTime';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { MrtTable } from '@mi-front/ui';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { BcrMatchesReportVerifiedItem } from '../../../station-reports.types';

export function VerifiedMatchesTable({ data }: { data: BcrMatchesReportVerifiedItem[] }) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        createDateTimeColumn<BcrMatchesReportVerifiedItem>($t, {
          id: 'match.datetime',
          accessor: (row) => row.match.datetime,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        }),
        createCustomIdColumn<BcrMatchesReportVerifiedItem>($t, {
          id: 'match.customId',
          accessor: (row) => row.match.customId,
          enableColumnFilter: true,
          filterFn: 'contains',
        }),
        {
          id: 'bcrEntry.name',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.verified.bcrName',
            defaultMessage: 'BCR Nombre',
          }),
          accessorFn: (row) => row.bcrEntry.name,
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
        },
        {
          id: 'match.matchedSchedule',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.verified.matchedSchedule',
            defaultMessage: 'Schedule',
          }),
          accessorFn: (row) => {
            return row.match.matchedSchedule?.datetime || null;
          },
          Cell: ({ row }) => {
            const matchedSchedule = row.original.match.matchedSchedule;
            if (matchedSchedule?.datetime) {
              return (
                <Chip
                  label={<LTime value={matchedSchedule.datetime} />}
                  size="small"
                  color="success"
                />
              );
            }
            return (
              <Chip
                label={$t({
                  id: 'audit.reportsScreen.bcrMatches.noSchedule',
                  defaultMessage: 'Sin schedule',
                })}
                size="small"
                color="warning"
              />
            );
          },
          enableSorting: true,
          enableColumnFilter: false,
          size: 150,
        },
        {
          id: 'bcrEntry.datetime',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.verified.bcrEntryDatetime',
            defaultMessage: 'BCR Entry Time',
          }),
          accessorFn: (row) => (row.bcrEntry?.datetime ? new Date(row.bcrEntry.datetime) : null),
          Cell: ({ row }) => {
            if (!row.original.bcrEntry?.datetime) return null;
            return (
              <Chip
                label={<LTime value={row.original.bcrEntry.datetime} showSeconds />}
                size="small"
                color="info"
                variant="outlined"
              />
            );
          },
          enableSorting: true,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        },
      ]}
    />
  );
}
